import { Select, SimpleGrid, Text, TextInput, rem } from '@mantine/core';
import { BiSolidDownArrow } from 'react-icons/bi';
import { MappingToComboBoxItem } from '@/schemas/converters/mappingShemasConverter';
import { getFetcher } from '@/api/fetchers';
import useSWR from 'swr';
import { type Mapping } from '@/schemas/API/GET/mapping/response';
import { DateInput, type DateValue } from '@mantine/dates';
import { dateFormat, dateFormatUI } from '@/index';
import dayjs from 'dayjs';
import { useEmployeeFormContext } from '../NewEmployeePage';

export const PersonalInfoCard: React.FC = () => {
  const form = useEmployeeFormContext();
  const icon = (
    <BiSolidDownArrow
      style={{ width: rem(10), height: rem(10), color: 'gray' }}
    />
  );

  const { data: genderMap } = useSWR<Mapping>('/mappings/sexes', getFetcher);

  const setDate = (d: DateValue) => {
    const date: string = dayjs(d).format(dateFormat);
    form.setFieldValue('birthdate', date);
  };

  const setTitle = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value.trim() === '' ? null : event.target.value;
    form.setFieldValue('title', value);
  };

  return (
    <div>
      <Text fw={700} size="lg" mt="lg">
        Osobní údaje
      </Text>
      <SimpleGrid cols={3}>
        <div>
          <TextInput
            mt="sm"
            variant="filled"
            radius="md"
            placeholder="titul"
            label="Titul"
            value={form.getInputProps('title').value}
            error={form.getInputProps('title').error}
            onChange={setTitle}
          />
          <Select
            mt="sm"
            variant="filled"
            radius="md"
            label="Pohlaví"
            allowDeselect={false}
            rightSection={icon}
            data={MappingToComboBoxItem(genderMap)}
            {...form.getInputProps('sex')}
          />
        </div>
        <div>
          <TextInput
            required
            mt="sm"
            variant="filled"
            radius="md"
            placeholder="jméno"
            label="Jméno"
            {...form.getInputProps('firstName')}
          />
          <TextInput
            required
            mt="sm"
            variant="filled"
            radius="md"
            placeholder="místo narození"
            label="Místo narození"
            {...form.getInputProps('birthplace')}
          />
        </div>
        <div>
          <TextInput
            required
            mt="sm"
            variant="filled"
            radius="md"
            placeholder="příjmení"
            label="Příjmení"
            {...form.getInputProps('lastName')}
          />
          <DateInput
            required
            mt="sm"
            variant="filled"
            radius="md"
            label="Datum narození"
            placeholder="datum narození"
            rightSection={icon}
            valueFormat={dateFormatUI}
            value={
              form.values.birthdate
                ? dayjs(form.values.birthdate, dateFormat).toDate()
                : null
            }
            onChange={setDate}
            error={form.getInputProps('birthdate').error}
            locale="cs"
          />{' '}
        </div>
      </SimpleGrid>
    </div>
  );
};
